export default __webpack_public_path__ + "22a6d5c806b57ce42c3d132b7beeb2ce.png";